/* @flow */

import type { $Configuration } from '../../types/Configuration';
import type { $Dealer } from '../../types/Dealer';
import type { $DealerFunction } from '../../types/Dealer';
import type { $DealerHighlightedActivityType } from '../../constants/DealerHighlightedActivityTypes';
import WidgetDealerKeys from '../../constants/WidgetDealerKeys';
import { getConfigurationMarketProperty } from '../../utils/WidgetUtils';
import { showWidgetField } from '../../utils/WidgetFieldUtils';

export function isDealerActivityType(dealer: $Dealer, activityTypeCode: string): boolean {
  return !!(dealer && dealer.functions && dealer.functions.find(
    (dealerFunction: $DealerFunction) => dealerFunction.activityCode === activityTypeCode
  ));
}

export function isMarketActivityTypeEnabled(
  configuration: $Configuration, marketCode: string, highlightedActivityTypePropertyKey: string, activityCode: string
): boolean {
  const property = getConfigurationMarketProperty(configuration, marketCode, highlightedActivityTypePropertyKey);
  return !!property && Array.isArray(property) && property.includes(activityCode);
}

export function renderHightlightedActivityIcon(
  dealerHighlightedActivityType: $DealerHighlightedActivityType, dealer: $Dealer,
  configuration: $Configuration, marketCode: string, widgetSettings: Object
): boolean {
  let renderIcon = false;

  const property = getConfigurationMarketProperty(
    configuration, marketCode, dealerHighlightedActivityType.marketPropertyKey);

  if (showWidgetField(widgetSettings, WidgetDealerKeys.DEALER_C_ACTIVITY_TYPES_HIGHLIGHTED, configuration) &&
  showWidgetField(widgetSettings, dealerHighlightedActivityType.fieldKey, configuration) &&
  property && Array.isArray(property) && property.length > 0) {
    for (const marketActivityType of property) {
      if (showWidgetField(widgetSettings, dealerHighlightedActivityType.fieldKey, configuration) &&
      isDealerActivityType(dealer, marketActivityType)) renderIcon = true;
    }
  }
  return renderIcon;
}
